import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { renderTextField, normalizeDecimal } from '../../../../../../components/reduxFields'
import { connect } from 'react-redux';
import { CommonButton } from '../../../../../../components/buttons'
import { getPatientGeneralSettingsDetail, savePatientGeneralSettings, getMasterData } from './actions/GeneralSettingsActions';

const validate = (values) => {
    const errors = {};
    if (!values.partialIntervalDuration) {
      errors.partialIntervalDuration = 'Please enter partial interval duration';
    }
    else if (values.partialIntervalDuration && values.partialIntervalDuration < 0.17) {
        errors.partialIntervalDuration = 'Partial interval duration should be greater than or equal to 0.17';
    }
    if (!values.momentaryIntervalDuration) {
      errors.momentaryIntervalDuration = 'Please enter momentary interval duration';
    }
    else if (values.momentaryIntervalDuration && values.momentaryIntervalDuration < 0.17) {
        errors.momentaryIntervalDuration = 'Momentary interval duration should be greater than or equal to 0.17';
    }
    return errors;
  };
  

  
class GeneralSettings extends Component {
    constructor(props) {
        super(props);
        this.handleNewRequest = this.handleNewRequest.bind(this);
    }

    componentWillMount() {       
        this.props.getPatientGeneralSettingsDetail(this.props.patientId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved_patientGeneralSettings && nextProps.saved_patientGeneralSettings !== this.props.saved_patientGeneralSettings) {
            this.props.getPatientGeneralSettingsDetail(this.props.patientId);
        }
    }

    handleNewRequest(input, selectedRecord) {
        input.onChange(selectedRecord.value);
    }

    onSubmit(formProps) {
        formProps = {
            id: formProps.id || null,
            patientId: this.props.patientId,
            ...formProps
        }
        this.props.savePatientGeneralSettings(formProps);
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))} >
                    <div className="row">
                        
                        <div className="col-sm-6 require">
                            <Field
                                name="partialIntervalDuration"
                                floatingLabelText="Partial Interval Duration (In mins)"
                                maxLength="5"
                                component={renderTextField}
                                normalize={normalizeDecimal}
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-sm-6 require">
                            <Field
                                name="momentaryIntervalDuration"
                                floatingLabelText="Momentary Interval Duration (In mins)"
                                maxLength="5"
                                component={renderTextField}
                                normalize={normalizeDecimal}
                                fullWidth={true}
                            />
                        </div>
                        
                    </div>
                    {this.props.addPermission ?
                        <div className="row">
                            <div className="col-sm-12 pt20 btn_rt">
                                {this.props.loading ?
                                    <CommonButton primary={true} className="loader_btn" disabled={true} label="Saving" />
                                    : <CommonButton type="submit" primary={true} label="Save" />}
                            </div>
                        </div>
                        : null
                    }
                </form>
            </div>
        )
    }
}

//const selector = formValueSelector('PatientGeneralSettingsForm');
const mapStateToProps = (state, ownProps) => {
    let initialValueData = null;
    if (ownProps.patientId && state.patient_generalSettings.patientGeneralSettingsDetails) {
        initialValueData = state.patient_generalSettings.patientGeneralSettingsDetails.data;
    }
    // console.log(initialValueData)

    // Start For Role Permission
    // let userActionPermission = [];
    // if (state.login.userPermission) {
    //     let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
    //     let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
    //     userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    // }

    // let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    // let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_GENERAL_SETTINGS")[0].permission : false;
       let addPermission =true;
    // End For Role Permission

    return {
        initialValues: initialValueData,        
        saved_patientGeneralSettings: state.patient_generalSettings.saved_patientGeneralSettings,
        loading: state.patient_generalSettings.loading,
        addPermission: addPermission, // For Role Permission
    };
};

GeneralSettings = reduxForm({
    form: 'PatientGeneralSettingsForm', // a unique identifier for this form
    validate,
    enableReinitialize: true,
})(GeneralSettings);


export default connect(mapStateToProps, { getPatientGeneralSettingsDetail, savePatientGeneralSettings, getMasterData })(GeneralSettings);


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/generalSettings/index.js